/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteDto
 */
export interface SiteDto {
    /**
     * 
     * @type {string}
     * @memberof SiteDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiteDto
     */
    name?: string | null;
}

export function SiteDtoFromJSON(json: any): SiteDto {
    return SiteDtoFromJSONTyped(json, false);
}

export function SiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function SiteDtoToJSON(value?: SiteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}


